import { render, staticRenderFns } from "./aShopSmsDetail.vue?vue&type=template&id=4b9858f9&scoped=true"
import script from "./aShopSmsDetail.vue?vue&type=script&lang=js"
export * from "./aShopSmsDetail.vue?vue&type=script&lang=js"
import style0 from "./aShopSmsDetail.vue?vue&type=style&index=0&id=4b9858f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9858f9",
  null
  
)

export default component.exports